import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '../../../../components/lists/list-item/list-item';
import { DataVariant, ListItemData } from '../../../../components/lists/list-item/types';
import { formatDate } from '../../../../helpers/date-formatters';
import { formatNumber } from '../../../../helpers/number-formatters';
import { MoneyTransitionListItem as ListItemDataInput } from '../../../../logic/graphql/types/types.d';
import { Paths } from '../../../../navigation/paths';
import { useIntl } from 'react-intl';

const MoneyTransitionListItem = (props: {
  listItem: ListItemDataInput;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const history = useHistory();
  const intl = useIntl();
  const handleOnClick = (): void => {
    history.push(Paths.money_transitions + '/' + props.listItem.transaction_code);
  };

  const data: ListItemData = {
    status: props.listItem.status,
    iconVisible: true,
    title: props.listItem.currency,
    transactionCode: props.listItem.transaction_code,
    detailBlocks: [
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'moneyTransitions.listItem.fromAccount' }),
            value: props.listItem.from_account,
          },
          {
            label: intl.formatMessage({ id: 'moneyTransitions.listItem.toAccount' }),
            value: props.listItem.to_account,
          },
        ],
      },
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'moneyTransitions.listItem.amount' }),
            value: formatNumber(props.listItem.amount, props.listItem.currency),
            variant: DataVariant.highlighted,
          },
        ],
      },
    ],
    date: formatDate(props.listItem.transfer_date),
  };

  return (
    <ListItem
      onClick={handleOnClick}
      data={data}
      style={props.style}
      mobileHeight={props.mobileHeight}
    />
  );
};

export default MoneyTransitionListItem;
